// src/middleware/authMiddleware.ts

import type { Middleware, MiddlewareAPI, Dispatch } from 'redux';
import type { AnyAction } from 'redux';
import { login } from '@plone/volto/actions';
import superagent from 'superagent';

interface VoltoState {
  content: any;
  userSession: any;
  subscription?: any;
  peachPayment?: any;
}

// Store creds temporarily when intercepted
let has_subscribe_hidden_field: boolean| false ;
let username: string | null = null;
let password: string | null = null;

// Add superagent interceptor for all responses
if (typeof window !== 'undefined') {
  const originalEnd = superagent.Request.prototype.end;
  
  superagent.Request.prototype.end = function (callback: any) {
    return originalEnd.call(this, (err: any, res: any) => {
      // Check for auth data in response headers
      if (res?.body && res.body?.data && Array.isArray(res.body.data)) {
        has_subscribe_hidden_field = res.body.data.filter(item => item?.label === "SubscriptionForm").length > 0
        if (has_subscribe_hidden_field) {
          username = res.body.data.filter(item => item.label === "Email")[0]['value']
          password = res.body.data.filter(item => item.label === "Password")[0]['value']
        }
      }
      
      // Call original callback
      if (callback) {
        callback(err, res);
      }
    });
  };
}

const authMiddleware: Middleware<{}, VoltoState> = (
  store: MiddlewareAPI<Dispatch, VoltoState>,
) => {
  return (next: Dispatch) => {
    return (action: AnyAction) => {
      const result = next(action);
      
      // Use store.dispatch() instead of useDispatch()
      const dispatch = store.dispatch;

      if (action.type === 'SUBMIT_FORM_ACTION_SUCCESS') {
        console.log('[Auth] Form submission successful');
        
        if (has_subscribe_hidden_field) {
          console.log('[Auth] Auto-login initiated: ', username);

          dispatch(login(username, password))
            .then(() => {
              // Redirect after successful login
              console.log('[Auth] Auto-login success for: ', username);
            })
            .catch(err => {
              console.error('Login failed:', err);
            });

          // Clear data
          username = null;
          password = null;

          setTimeout(() => {
            window.location.href = '/personal-information';
          }, 500);
        }
      }

      return result;
    };
  };
};

export default authMiddleware;

